import { Outlet } from "react-router-dom";
import Header from "./Header";
import UserSidebar from "./UserSidebar";

const UserLayout = () => {
    return (
        <div className="min-h-screen flex flex-col bg-[#F9FAFC]">        
            <Header variant="white" /> 
            <main className="flex-1 w-full pt-20 sm:pt-24 pb-12">
                <div className="container mx-auto px-3 sm:px-6 lg:px-8">
                    <div className="flex flex-col md:flex-row gap-6 lg:gap-8 items-start">
                        <div className="w-full md:w-64 lg:w-72 shrink-0">
                            <UserSidebar />
                        </div>
                        <div className="flex-1 min-w-0 w-full">
                            <Outlet />
                        </div>
                    </div>
                </div>                
            </main>          
        </div>
    );
}
export default UserLayout;